export default "__VITE_ASSET__33f4756f__"